import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { queryClient } from 'configs/queryClient';
import useB2CVerificationRequestQuery from 'hooks/useB2CVerificationRequestQuery';

export type UpdateB2CVerificationDocsMutationData = NonNullable<
  operations['updateB2CVerificationDocumentStates']['requestBody']
>['content']['application/json'];

async function updateB2CVerificationDocs(apiClient: ApiClient, id: string, data: UpdateB2CVerificationDocsMutationData) {
  return apiClient.PUT(`/op/v2/b2c-verification/{id}/update-document-states`, {
    params: { path: { id } },
    body: data,
  });
}

export function useUpdateB2CVerificationDocsMutation(id: string, mode: 'id' | 'rc') {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: (data: UpdateB2CVerificationDocsMutationData) => throwOnError(updateB2CVerificationDocs(apiClient, id, data)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useB2CVerificationRequestQuery.getKey(id) });
    },
    mutationKey: ['UpdateB2CVerificationDocs', id, mode],
  });
}
